"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// This is the export of  the empty object for fs resoluton in webpack.
var _default = exports.default = {};